
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.75 0.25C7.33579 0.25 7 0.585786 7 1V4.08249C4.91369 5.23077 3.5 7.45029 3.5 10V14.0455C3.5 15.263 2.51299 16.25 1.29545 16.25H1.25C0.835786 16.25 0.5 16.5858 0.5 17C0.5 17.4142 0.835786 17.75 1.25 17.75H6.57577C6.62352 17.984 6.69363 18.2134 6.78545 18.4351C6.97391 18.89 7.25013 19.3034 7.59835 19.6517C7.94657 19.9999 8.35997 20.2761 8.81494 20.4645C9.26991 20.653 9.75754 20.75 10.25 20.75C10.7425 20.75 11.2301 20.653 11.6851 20.4645C12.14 20.2761 12.5534 19.9999 12.9017 19.6517C13.2499 19.3034 13.5261 18.89 13.7145 18.4351C13.8064 18.2134 13.8765 17.984 13.9242 17.75H19.25C19.6642 17.75 20 17.4142 20 17C20 16.5858 19.6642 16.25 19.25 16.25H19.2045C17.987 16.25 17 15.263 17 14.0455V10C17 7.45029 15.5863 5.23077 13.5 4.08249V1C13.5 0.585786 13.1642 0.25 12.75 0.25H7.75ZM12 3.47906V1.75H8.5V3.47906C9.05812 3.32966 9.64476 3.25 10.25 3.25C10.8552 3.25 11.4419 3.32966 12 3.47906ZM16.2271 16.25H4.27293C4.72978 15.634 5 14.8713 5 14.0455V10C5 7.1005 7.3505 4.75 10.25 4.75C13.1495 4.75 15.5 7.1005 15.5 10V14.0455C15.5 14.8713 15.7702 15.634 16.2271 16.25ZM8.17127 17.861C8.15608 17.8244 8.14188 17.7873 8.12868 17.75H12.3713C12.3581 17.7873 12.3439 17.8244 12.3287 17.861C12.2157 18.134 12.0499 18.3821 11.841 18.591C11.6321 18.7999 11.384 18.9657 11.111 19.0787C10.8381 19.1918 10.5455 19.25 10.25 19.25C9.95453 19.25 9.66194 19.1918 9.38896 19.0787C9.11598 18.9657 8.86794 18.7999 8.65901 18.591C8.45008 18.3821 8.28434 18.134 8.17127 17.861Z","fill":"#357D67"}})])
          )
        }
      }
    